import { useQuery } from "@tanstack/react-query";

import { ForecastError } from "../api/client";
import { fetchAlerts } from "../api/alerts";
import { useSelectedLocation } from "./useSelectedLocation";

export function useAlerts() {
  const { location } = useSelectedLocation();

  return useQuery({
    queryKey: ["alerts", location.lat, location.lon],
    queryFn: () => fetchAlerts(location.lat, location.lon),
    staleTime: 2 * 60_000,
    retry: (failureCount, error) => {
      if (error instanceof ForecastError && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 2;
    },
    retryDelay: 1000,
  });
}
